import type { Eu } from "@horofacial/shared";
import { CalendarPlus, FileText, Receipt, UserPlus, type LucideIcon } from "lucide-react";
import { podeEditar } from "../lib/sessao";

export type AcaoNovo = { rotulo: string; icone: LucideIcon; para: string; search?: Record<string, string> };

/** O que o botão "Novo" e a busca ⌘K oferecem para criar, conforme o que o usuário pode editar. */
export function acoesNovo(eu: Eu): AcaoNovo[] {
  const todas: (AcaoNovo & { menu: string })[] = [
    { rotulo: "Agendamento", icone: CalendarPlus, para: "/agenda", search: { novo: "agendamento" }, menu: "/agenda" },
    { rotulo: "Paciente", icone: UserPlus, para: "/pacientes/novo", menu: "/pacientes" },
    { rotulo: "Cobrança", icone: Receipt, para: "/cobrar", menu: "/cobrar" },
    { rotulo: "Orçamento", icone: FileText, para: "/orcamentos", search: { aba: "orcamentos" }, menu: "/orcamentos" },
  ];
  return todas.filter((a) => podeEditar(eu, a.menu));
}
